import React, { useState } from "react";
import styles from "./koifish-cafe.module.css";
import Head from "next/head";
import EventIcon from "@mui/icons-material/Event";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PlaceIcon from "@mui/icons-material/Place";
import LanguageIcon from "@mui/icons-material/Language";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome"; 

import TextField from "@mui/material/TextField";
import {
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Button,
  FormHelperText,
  Modal,
  Box,
} from "@mui/material";

function index() {
      const [user, setUser] = useState({});
      const [error, setError] = useState({});
      const [successOpen, setSuccessOpen] = useState(false);
      const closeSuccess = () => setSuccessOpen(false);
      const [wheelOpen, setWheelOpen] = useState(false);
      const [submitting, setSubmitting] = useState(false);
      const [submitError, setSubmitError] = useState("");
    
      const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setError({ ...error, [name]: undefined });
        setUser({ ...user, [name]: value });
      };
    
      // <--------------------------- Phone Formatting --------------------------->
      const phoneFormatting = (event) => {
        if (event.target.value.split("").length <= 18) {
          const formatted = event.target.value.replace(/[^\d+\-()\s]/g, "");
          const name = event.target.name;
          setUser({ ...user, [name]: formatted });
          setError({ ...error, [name]: undefined });
        }
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
    
        let errorObject = {};
    
        if (!user?.first_name) errorObject.first_name = "First Name is Required";
        if (!user?.last_name) errorObject.last_name = "Last Name is Required";
        if (!user?.email) errorObject.email = "Email is Required";
        else if (!/\S+@\S+\.\S+/.test(user.email))
          errorObject.email = "* Invalid email format";
        if (!user?.contact_number)
          errorObject.contact_number = "Telephone Number is Required";
        if (!user?.lives_in_danang)
          errorObject.lives_in_danang = "Please select an option";
        if (!user?.experience)
          errorObject.experience = "Please select your experience level";
        if (!user?.age) errorObject.age = "Age is Required";
        if (!user?.gender) errorObject.gender = "Gender is Required";
        if (!user?.believe_in_astrology)
          errorObject.believe_in_astrology = "Please select an option";
    
        if (Object.keys(errorObject).length > 0) {
          setError(errorObject);
          return;
        }
    
        setError({});
        setSubmitError("");
    
        // POST to the Da Nang meetup registration endpoint. Field values already
        // match the API enums (see the *Array definitions below).
        const payload = {
          firstName: user.first_name.trim(),
          lastName: user.last_name.trim(),
          email: user.email.trim(),
          phone: user.contact_number.trim(),
          livesInDaNang: user.lives_in_danang,
          astrologyExperience: user.experience,
          age: Number(user.age),
          gender: user.gender,
          believesInAstrology: user.believe_in_astrology,
        };
    
        try {
          setSubmitting(true);
          const res = await fetch(
            "https://api.divineinfinitebeing.com/event/meetup-register-koifishcafe",
            {
              method: "POST",
              headers: {
                accept: "*/*",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            }
          );
    
          // The API returns 200 with { success:false } for handled cases
          // (e.g. duplicate email), so branch on the body, not just res.ok.
          const data = await res.json().catch(() => null);
    
          if (res.ok && data?.success) {
            setSuccessOpen(true);
            setUser({});
          } else {
            setSubmitError(
              data?.message ||
                "Something went wrong while reserving your seat. Please try again."
            );
          }
        } catch (err) {
          setSubmitError(
            "Network error — please check your connection and try again."
          );
        } finally {
          setSubmitting(false);
        }
      };
    
      // `val`s below are the exact enum values the registration API accepts.
      const YesNoArray = [
        { name: "Yes", val: "Yes" },
        { name: "No", val: "No" },
      ];
    
      const ExperienceArray = [
        { name: "Beginner", val: "Beginner" },
        { name: "Some Experience", val: "Some Experience" },
        { name: "Advanced", val: "Advanced" },
      ];
    
      const GenderArray = [
        { name: "Male", val: "Male" },
        { name: "Female", val: "Female" },
        { name: "Other", val: "Other" },
      ];

  return (
    <>
      <Head>
        <title>Astrology Meetup at Koi Fish Cafe, Da Nang – September 18 | School of Our Divine Infinite Being</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="description"
          content="Free 3-hour Astrology Meetup at Koi Fish Cafe, Da Nang on Friday, September 18, 6–9 PM. Discover how the planets shape your identity and destiny with Eddie Paredes. Limited to 30 students — register now."
        />
        <meta
          name="keywords"
          content="Astrology Meetup Da Nang, Koi Fish Cafe Da Nang, Astrology Class Vietnam, Natal Chart Da Nang, Planets Astrology, Eddie Paredes, School of Our Divine Infinite Being, free astrology class Vietnam"
        />
        <meta property="og:title" content="Unlock the Secrets of the Planets — Astrology Meetup at Koi Fish Cafe, Da Nang" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Discover how the cosmos shapes your life. A free astrology class on Friday, September 18 at Koi Fish Cafe, Da Nang. Limited to 30 students."
        />
        <meta property="og:url" content="https://www.divineinfinitebeing.com/KoiFishCafe" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Unlock the Secrets of the Planets — Astrology Meetup at Koi Fish Cafe, Da Nang" />
        <meta
          name="twitter:description"
          content="Free astrology class in Da Nang on September 18. Explore how the planets shape your identity and destiny. Limited to 30 students — register now."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.divineinfinitebeing.com/KoiFishCafe" />
      </Head>

      <div className={styles.danang2_landing_page_main}>
        <div className={styles.danang2_bnr_main}>
          <div className={styles.common_width}>
            <div className={styles.danang2_bnr_main_wrpr}>
              <div className={styles.danang2_bnr_left_sec}>
                <img
                  src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/danang_2/daNang2_landing_pg_divine_logo.webp"
                  alt="logo"
                />

                <div className={styles.padding_left_cont_sec}>
                  <p className={styles.font_33}>
                    Discover How the Cosmos Shapes Your Life
                  </p>
                  <h1 className={styles.font_91}>Class is at no cost.</h1>
                  <p className={styles.koi_green_head}>
                    Unlock the Secrets of the Planets:
                  </p>
                  <p className={`${styles.font_22} ${styles.mb_25}`}>
                    Astrology for Personal Identity, Destiny &amp; Chart Mastery
                  </p>
                </div>
                <p className={`${styles.font_25} ${styles.mb_25}`}>
                  <span>Join us</span> for an immersive <span>Astrology Meetup</span> where you’ll explore
                  the powerful influence of the planets on your personality,
                  life path, and destiny. Whether you’re new to astrology or
                  seeking a deeper refresher, this interactive class will give
                  you practical insights you can apply immediately.
                </p>

                <div className={styles.bnr_red_arrow_bar}>
                  <h3 className={styles.font_42}>
                    Limited to 30 students only — Please register on this page
                    to secure your spot.
                  </h3>
                </div>
              </div>

              <div className={styles.danang2_bnr_right_form_sec}>
                <div className={styles.form_sec_blue_box}>
                    <div className={styles.top_heading_section}>
                        <div className={styles.top_heading_sub_box}>
                            <h2 className={styles.font_28}>Fill out this form to secure your spot</h2>
                        </div>
                    </div>

                    <div className={styles.form_sec_main}>
                        <form>
                            <TextField
                              className={styles.from_input}
                              name="first_name"
                              value={user?.first_name || ""}
                              onChange={handleInput}
                              error={error.first_name ? true : false}
                              helperText={error.first_name}
                              variant="outlined"
                              label="First Name"
                            />

                            <TextField
                              className={styles.from_input}
                              name="last_name"
                              value={user?.last_name || ""}
                              onChange={handleInput}
                              error={error.last_name ? true : false}
                              helperText={error.last_name}
                              variant="outlined"
                              label="Last Name"
                            />

                            <TextField
                              className={styles.from_input}
                              name="email"
                              value={user?.email || ""}
                              onChange={handleInput}
                              error={error.email ? true : false}
                              helperText={error.email}
                              variant="outlined"
                              label="Email"
                            />

                            <TextField
                              className={styles.from_input}
                              variant="outlined"
                              fullWidth
                              name="contact_number"
                              type="text"
                              label="Telephone Number"
                              onChange={phoneFormatting}
                              value={user?.contact_number || ""}
                              error={error.contact_number ? true : false}
                              helperText={error.contact_number}
                            />

                            <FormControl className={styles.from_input}>
                              <InputLabel id="danang-label">
                                Do you live in Da Nang?
                              </InputLabel>
                              <Select
                                className="contact_select_menu"
                                labelId="danang-label"
                                label="Do you live in Da Nang?"
                                name="lives_in_danang"
                                onChange={handleInput}
                                value={user?.lives_in_danang || ""}
                                error={error.lives_in_danang ? true : false}
                              >
                                {YesNoArray.map((item, key) => (
                                  <MenuItem
                                    className="contact_menu_item"
                                    value={item.val}
                                    key={key}
                                  >
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {error.lives_in_danang && (
                                <FormHelperText>{error.lives_in_danang}</FormHelperText>
                              )}
                            </FormControl>

                            <FormControl className={styles.from_input}>
                              <InputLabel id="experience-label">
                                Experience with Astrology
                              </InputLabel>
                              <Select
                                className="contact_select_menu"
                                labelId="experience-label"
                                label="Experience with Astrology"
                                name="experience"
                                onChange={handleInput}
                                value={user?.experience || ""}
                                error={error.experience ? true : false}
                              >
                                {ExperienceArray.map((item, key) => (
                                  <MenuItem
                                    className="contact_menu_item"
                                    value={item.val}
                                    key={key}
                                  >
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {error.experience && (
                                <FormHelperText>{error.experience}</FormHelperText>
                              )}
                            </FormControl>

                            <TextField
                              className={styles.from_input}
                              name="age"
                              type="number"
                              value={user?.age || ""}
                              onChange={handleInput}
                              error={error.age ? true : false}
                              helperText={error.age}
                              variant="outlined"
                              label="Your Age"
                              inputProps={{ min: 0, max: 120 }}
                            />

                            <FormControl className={styles.from_input}>
                              <InputLabel id="gender-label">Gender</InputLabel>
                              <Select
                                className="contact_select_menu"
                                labelId="gender-label"
                                label="Gender"
                                name="gender"
                                onChange={handleInput}
                                value={user?.gender || ""}
                                error={error.gender ? true : false}
                              >
                                {GenderArray.map((item, key) => (
                                  <MenuItem
                                    className="contact_menu_item"
                                    value={item.val}
                                    key={key}
                                  >
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {error.gender && (
                                <FormHelperText>{error.gender}</FormHelperText>
                              )}
                            </FormControl>

                            <FormControl className={styles.from_input}>
                              <InputLabel id="believe-label">
                                Do you believe in Astrology?
                              </InputLabel>
                              <Select
                                className="contact_select_menu"
                                labelId="believe-label"
                                label="Do you believe in Astrology?"
                                name="believe_in_astrology"
                                onChange={handleInput}
                                value={user?.believe_in_astrology || ""}
                                error={error.believe_in_astrology ? true : false}
                              >
                                {YesNoArray.map((item, key) => (
                                  <MenuItem
                                    className="contact_menu_item"
                                    value={item.val}
                                    key={key}
                                  >
                                    {item.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {error.believe_in_astrology && (
                                <FormHelperText>
                                  {error.believe_in_astrology}
                                </FormHelperText>
                              )}
                            </FormControl>

                            {submitError && (
                              <p className={styles.danang_submit_error} role="alert">
                                {submitError}
                              </p>
                            )}

                            <Button className={styles.submit_button}
                              variant="contained"
                              type="submit"
                              onClick={handleSubmit}
                              disabled={submitting}
                            >
                              {submitting ? "Submitting…" : "Submit"}
                            </Button>
                        </form>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.danang2_blck1_main}>
            <div className={styles.common_width}>
                <div className={styles.blck1_green_box}>
                    <div className={styles.blck1_green_box_left_sec}>
                        <h2 className={styles.koi_about_head}>About This Class</h2>
                        <p className={styles.koi_about_sub}>Taught in English <span>|</span> Tropical Western Astrology</p>
                        <p className={styles.koi_about_txt}>This session is conducted in English and follows the Tropical Western Astrology system — approachable for newcomers and enriching for seasoned students alike.</p>
                    </div>
                    <div className={styles.blck1_green_box_right_sec}>
                        <h2 className={styles.font_68}>Friday<span>September 18th</span></h2>
                        <p className={styles.font_32}>68-70 Hồ Sỹ Tân, Sơn Trà, Đà Nẵng, Vietnam</p>
                        <h3 className={styles.koi_time_row}>
                          6:00 PM – 9:00 PM
                          <span className={styles.koi_venue}><PlaceIcon /> Koi Fish Cafe</span>
                        </h3>
                    </div>
                </div>
            </div>
        </div>

        <div className={styles.danang2_blck2_main}>
            <div className={styles.common_width}>
                <div className={`${styles.danang2_blck2_wrpr} ${styles.danang2_blck2_wrpr_part_1}`}>
                    <div className={styles.danang2_blck2_cont_sec}>
                        <h2 className={`${styles.font_42} ${styles.mb_25}`}>What You’ll <span>Experience</span></h2>
                        <p className={styles.font_30}>This 3-hour session blends inspiring lecture with hands-on workshop activities. You’ll learn:</p>

                        <h5 className={styles.yellow_bullet_cont}>The core meaning and energy of each planet in astrology</h5>
                        <h5 className={styles.yellow_bullet_cont}>How planets shape your personal identity and unique character</h5>
                        <h5 className={styles.yellow_bullet_cont}>Their role in guiding your destiny, opportunities, and life lessons</h5>
                        <h5 className={styles.yellow_bullet_cont}>How to interpret planets in a natal chart with clarity and confidence</h5>
                        <h5 className={styles.yellow_bullet_cont}>Practical techniques for using planetary insights in daily life and decision-making</h5>

                        <p className={styles.font_30} style={{marginTop: '15px'}}>Materials are provided — no prior preparation needed. Bring your curiosity, a notebook if you like, and an open heart.</p>
                    </div>

                    <div className={styles.danang2_blck2_image_sec}>
                        <img src="/image/koifish-cafe/koi_what_experience_img.webp?v=6" alt="Woman reading a glowing astrological book"/>
                    </div>
                </div>

                <div className={`${styles.danang2_blck2_wrpr} ${styles.danang2_blck2_wrpr_part_2}`}>
                    <div className={styles.danang2_blck2_image_sec}>
                        <img src="/image/koifish-cafe/koi_beginners_img.webp?v=6" alt="Zodiac and planetary glyphs"/>
                    </div>

                    <div className={styles.danang2_blck2_cont_sec}>
                        <h2 className={`${styles.font_42} ${styles.mb_25}`}>Perfect For Both Beginners & <span>Advanced Students</span></h2>

                        <h5 className={styles.yellow_bullet_cont}><span className={styles.koi_label}>Beginners:</span>Build a strong foundational understanding in a supportive, judgment-free space.</h5>
                        <h5 className={styles.yellow_bullet_cont}><span className={styles.koi_label}>Advanced Students:</span>Gain fresh perspectives, refine your chart-reading skills, and connect with like-minded astrologers.</h5>

                        <p className={styles.font_30} style={{marginTop: '15px'}}>Leave with new knowledge, practical tools, and a richer connection to the cosmic forces at work in your life.</p>
                    </div>
                </div>
            </div>
        </div>

        <div className={styles.danang2_blck3_main}>
            <div className={styles.common_width}>
                <div className={styles.danang2_blck3_blue_box_main}>
                    <div className={styles.blck3_blue_box_left_cont}>
                        <h2 className={`${styles.font_42} ${styles.mb_25}`}>Your Guide: Eddie Paredes</h2>
                        <p className={styles.font_30}>Taught by <span>Eddie Paredes</span> of the School of Our Divine Infinite Being. Eddie brings a clear, intuitive, and transformative approach to astrology, blending ancient wisdom with practical modern application. Learn directly from an experienced teacher dedicated to helping you awaken your highest potential.</p>
                        <div className={styles.btn_sec}>
                            <a className={`${styles.sky_btn} ${styles.font_30}`} href="https://www.divineinfinitebeing.com/">www.divineinfinitebeing.com</a>
                        </div>
                    </div>
                    <div className={styles.right_image}>
                        <img src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/danang_2/beto_paredes_image.webp" alt="Eddie Paredes" />
                    </div>
                </div>
            </div>
        </div>

        <div className={styles.danang2_blck4_main}>
            <div className={styles.common_width}>
                <div className={styles.danang2_blck4_main_wrpr}>
                    <div className={styles.danang2_blck4_left_sec}>
                        <h2 className={`${styles.font_42} ${styles.mb_25}`}>Why  <span>Attend?</span></h2>

                        <h5 className={styles.yellow_bullet_cont}>Deepen self-understanding and clarity about your life path</h5>
                        <h5 className={styles.yellow_bullet_cont}>Connect with a conscious community in Da Nang</h5>
                        <h5 className={styles.yellow_bullet_cont}>Enjoy a beautiful wellness space with cafe vibes</h5>
                        <h5 className={styles.yellow_bullet_cont}>Take home lasting insights and astrological tools</h5>
                    </div>
                    <div className={styles.danang2_blck4_right_sec_yellow_box}>
                        <h2 className={styles.koi_limit_line}>Space is strictly <span>limited to 30 students</span>. The class is free.</h2>
                        <h2 className={styles.koi_limit_line}>Please register on this page to reserve your seat.</h2>
                    </div>
                </div>
            </div>
        </div>

      </div>

      {/* ---------------- Success modal ---------------- */}
      <Modal
        open={successOpen}
        onClose={closeSuccess}
        aria-labelledby="danang-success-title"
        className={styles.danang_modal_root}
      >
        <Box className={styles.danang_modal_box}>
          <div className={styles.danang_modal_inner}>
            <span className={styles.danang_modal_close} onClick={closeSuccess}>
              &times;
            </span>

            <div className={styles.danang_modal_glow}>
              <svg
                className={styles.danang_check}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  className={styles.danang_check_circle}
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  className={styles.danang_check_mark}
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
              <span className={styles.danang_spark} data-i="1"></span>
              <span className={styles.danang_spark} data-i="2"></span>
              <span className={styles.danang_spark} data-i="3"></span>
              <span className={styles.danang_spark} data-i="4"></span>
              <span className={styles.danang_spark} data-i="5"></span>
              <span className={styles.danang_spark} data-i="6"></span>
            </div>

            <h2 id="danang-success-title" className={styles.danang_modal_title}>
              You&rsquo;re Registered!
            </h2>
            <p className={styles.danang_modal_text}>
              Your seat for the <span>Da Nang Astrology Meetup</span> is
              reserved. We&rsquo;ll see you on <span>Friday, September 18th</span> at
              Koi Fish Cafe. A confirmation will follow by email.
            </p>

            <button
              type="button"
              className={styles.danang_modal_btn}
              onClick={closeSuccess}
            >
              Wonderful!
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default index;
